import { IconPhoto, IconVideo, IconLink } from '@tabler/icons-react';
import { ContentMediaType } from '@/types/contentItem';

// Single source of truth for content-library media-type presentation.
// Previously duplicated independently across ResourceFinderCard, ContentCardGrid,
// ContentStudioPage, PlaylistBuilderPage, and TrainingProgramTab.
export const MEDIA_TYPE_LABEL_KEY: Record<ContentMediaType, string> = {
  [ContentMediaType.IMAGE]: 'contentLibrary.mediaTabImage',
  [ContentMediaType.VIDEO]: 'contentLibrary.mediaTypeVideo',
  [ContentMediaType.EMBED]: 'contentLibrary.mediaTabVideoLink',
};

export const MEDIA_TYPE_ICON: Record<ContentMediaType, typeof IconPhoto> = {
  [ContentMediaType.IMAGE]: IconPhoto,
  [ContentMediaType.VIDEO]: IconVideo,
  [ContentMediaType.EMBED]: IconLink,
};
